import React from 'react'
import { getDate, getYear } from 'date-fns'
const Footer = () => {
  return (
    <footer className="footer mt-auto py-2 bg-light">
      <div className="container text-center">
        <small className="text-muted">Copyright ⓒ 1995-{getYear(new Date())} Samsung. All Rights Reserved.</small>
      </div>
    </footer>
  )
}

export default Footer
